import * as React from "react";
const TesouraIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <mask
      id="mask0_7021_745"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={32}
      height={32}
    >
      <rect
        width={32}
        height={32}
        transform="matrix(1 0 0 -1 0 32)"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_7021_745)">
      <path
        d="M25.9349 3.59262L15.9769 13.532L12.2466 9.80129C12.4659 9.43618 12.6003 9.0884 12.6496 8.75795C12.6989 8.42751 12.7236 8.06373 12.7236 7.66662C12.7236 6.20662 12.2364 4.98951 11.2619 4.01529C10.2875 3.04084 9.07027 2.55362 7.61027 2.55362C6.1505 2.55362 4.9365 3.04084 3.96827 4.01529C3.00027 4.98951 2.51627 6.20662 2.51627 7.66662C2.51627 9.12662 3.00027 10.3437 3.96827 11.318C4.9365 12.2924 6.1505 12.7796 7.61027 12.7796C7.98516 12.7796 8.35772 12.7272 8.72794 12.6223C9.09794 12.5176 9.4815 12.3667 9.87861 12.1696L13.5756 15.8666L9.81194 19.6303C9.44661 19.4776 9.08205 19.3712 8.71827 19.311C8.3545 19.2505 7.98516 19.2203 7.61027 19.2203C6.1505 19.2203 4.9365 19.7075 3.96827 20.682C3.00027 21.6562 2.51627 22.8733 2.51627 24.3333C2.51627 25.7933 3.00027 27.0104 3.96827 27.9846C4.9365 28.9591 6.1505 29.4463 7.61027 29.4463C9.07027 29.4463 10.2875 28.9591 11.2619 27.9846C12.2364 27.0104 12.7236 25.7933 12.7236 24.3333C12.7236 23.9362 12.7021 23.5613 12.6589 23.2086C12.6161 22.856 12.5119 22.5193 12.3466 22.1986L29.5176 5.02762V3.59262H25.9349ZM20.2306 17.5666L17.7103 20.068L25.9349 28.274H29.5366V26.8913L20.2306 17.5666ZM9.66827 22.2846C10.2336 22.8437 10.5163 23.5266 10.5163 24.3333C10.5163 25.14 10.2336 25.8228 9.66827 26.382C9.10316 26.9408 8.41716 27.2203 7.61027 27.2203C6.80361 27.2203 6.12083 26.9408 5.56194 26.382C5.00305 25.8228 4.72361 25.14 4.72361 24.3333C4.72361 23.5266 5.00305 22.8437 5.56194 22.2846C6.12083 21.7257 6.80361 21.4463 7.61027 21.4463C8.41716 21.4463 9.10316 21.7257 9.66827 22.2846ZM16.7199 15.1906C16.9048 15.3755 16.9973 15.6008 16.9973 15.8666C16.9973 16.1324 16.9048 16.3577 16.7199 16.5426C16.5348 16.7277 16.3094 16.8203 16.0436 16.8203C15.778 16.8203 15.5527 16.7277 15.3676 16.5426C15.1827 16.3577 15.0903 16.1324 15.0903 15.8666C15.0903 15.6008 15.1827 15.3755 15.3676 15.1906C15.5527 15.0055 15.778 14.913 16.0436 14.913C16.3094 14.913 16.5348 15.0055 16.7199 15.1906ZM9.66827 5.61795C10.2336 6.17706 10.5163 6.85995 10.5163 7.66662C10.5163 8.47329 10.2336 9.15618 9.66827 9.71529C9.10316 10.2742 8.41716 10.5536 7.61027 10.5536C6.80361 10.5536 6.12083 10.2742 5.56194 9.71529C5.00305 9.15618 4.72361 8.47329 4.72361 7.66662C4.72361 6.85995 5.00305 6.17706 5.56194 5.61795C6.12083 5.05906 6.80361 4.77962 7.61027 4.77962C8.41716 4.77962 9.10316 5.05906 9.66827 5.61795Z"
        fill="#1C1B1F"
      />
    </g>
  </svg>
);
export default TesouraIcon;